import React, { memo, ReactNode, useEffect, useState } from 'react'
import { Tabs } from 'antd'
import { useTranslation } from '@/services/i18n'
import { WalletPermissionEnum, UserRoleEnum, PermissionKeysEnum } from '@/constants/enum'
import { useSelectWorkspaceUserInfo } from '@/hooks/user'
import Api from './pannels/API'
import Strategy from './pannels/Strategy'
import Log from './pannels/Log'
import styles from './index.module.scss'
import WhiteList from './pannels/WhiteList'
import { useIsManagement } from '@/hooks/permission'

type SettingTab = {
  key: string
  label: string
  children?: ReactNode
}

const Setting = memo(() => {
  const { t } = useTranslation()
  const workspaceMember = useSelectWorkspaceUserInfo()
  const settingTabs: SettingTab[] = [
    {
      key: WalletPermissionEnum.WHITE_LIST,
      label: t('common.whiteList'),
    },
    {
      key: WalletPermissionEnum.TRADE_POLICY,
      label: t('policy.policy'),
    },
    {
      key: WalletPermissionEnum.API_KEY,
      label: `API`,
    },
    {
      key: 'AUDIT_LOG_KEY',
      label: t('setting.auditLog'),
    },
  ]
  const settingButtons = (): SettingTab[] => {
    if (!workspaceMember?.permissions) return []
    const btns = settingTabs.filter(
      (b: SettingTab) =>
        workspaceMember?.permissions.some(v => v?.permissionKey === b.key) ||
        (workspaceMember.role !== UserRoleEnum.MEMBER && b.key === 'AUDIT_LOG_KEY')
    )
    return btns
  }
  const isWhiteManage = useIsManagement(PermissionKeysEnum.MANAGEMENT_VAULT_ADDRESS)
  const [activeKey, setActiveKey] = useState<string>('')
  useEffect(() => {
    setActiveKey(
      isWhiteManage ? WalletPermissionEnum.WHITE_LIST : WalletPermissionEnum.TRADE_POLICY
    )
  }, [isWhiteManage])

  const getItems = () => {
    const tabs = settingButtons()
    tabs.forEach(item => {
      if (item.label === t('policy.policy')) {
        item.children = <Strategy />
      } else if (item.label === 'API') {
        item.children = <Api />
      } else if (item.label === t('setting.auditLog')) {
        item.children = <Log />
      } else if (item.label === t('common.whiteList')) {
        item.children = <WhiteList />
      }
    })
    return tabs
  }
  const items = getItems()

  return (
    <div className={styles.container}>
      <Tabs
        items={items}
        size="large"
        className={styles.tabs}
        animated={true}
        // 销毁的目的是减少list的轮询
        destroyInactiveTabPane={true}
        activeKey={activeKey}
        onChange={(activeKey: string) => {
          setActiveKey(activeKey)
        }}
      />
    </div>
  )
})

export default Setting
